import { Field, useFormikContext } from 'formik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import withStyles from '@material-ui/styles/withStyles';
import {
  ADD_CORROSION_LOG_FORM_FEILDS,
  ADD_CORROSION_LOG_FORM_FEILDS_LABELS,
} from 'features/wells/corrosion/helpers/corrosionlogs.constants';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import DatePickerFormik from 'app/components/form/formik/DatePickerFormik';

import { Grid } from '@material-ui/core';
import { fromJS } from 'immutable';
import { useEffect } from 'react';

import { Format } from 'app/app.constants';

const AddLogFileFormFields = ({ classes, tools, serviceProviders }) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      !values[ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER] &&
      serviceProviders.length > 0
    )
      setFieldValue(
        ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER,
        serviceProviders[0].id,
      );

    if (!values[ADD_CORROSION_LOG_FORM_FEILDS.TOOL] && tools.length > 0)
      setFieldValue(ADD_CORROSION_LOG_FORM_FEILDS.TOOL, tools[0].id);
  }, [serviceProviders, tools, values, setFieldValue]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Field
            fullWidth
            label={ADD_CORROSION_LOG_FORM_FEILDS_LABELS.FILE_NAME}
            margin="none"
            name={ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME}
            component={TextFieldFormik}
            className={classes.field}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            fullWidth
            margin="none"
            name={ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE}
            className={classes.field}
          >
            {({ form, ...formik }) => (
              <DatePickerFormik
                autoOk
                label={ADD_CORROSION_LOG_FORM_FEILDS_LABELS.LOG_DATE}
                form={form}
                {...formik}
                format={Format.date_dayfirst}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <SelectTextFieldFormik
            label={ADD_CORROSION_LOG_FORM_FEILDS_LABELS.SERVICE_PROVIDER}
            margin="none"
            items={fromJS(serviceProviders)}
            name={ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER}
            getItemValue={(organization) => organization.get('id')}
            getItemName={(organization) => organization.get('name')}
            displayEmpty={false}
            otherOption={'Please select Service Provider'}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectTextFieldFormik
            label={ADD_CORROSION_LOG_FORM_FEILDS_LABELS.TOOL}
            margin="none"
            items={fromJS(tools)}
            name={ADD_CORROSION_LOG_FORM_FEILDS.TOOL}
            getItemValue={(organization) => organization.get('id')}
            getItemName={(organization) => organization.get('name')}
            displayEmpty={false}
          />
        </Grid>
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  fieldWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textfieldLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      background: theme.palette.background.default,
    },
  },
  field: {
    padding: theme.spacing(1),
  },
});

export default withStyles(styles)(AddLogFileFormFields);
